jQuery(document).ready(function () {
  var flag = true;
  function checkVisibility() {
    var footer = jQuery('.page-template-post-page footer, body.blog footer, body.archive.category footer');
    if (footer.length) {
      var blockTop = footer.offset().top;
      var blockHeight = footer.outerHeight();
      var windowHeight = jQuery(window).height();
      var scrollPosition = jQuery(window).scrollTop();
      if (flag && scrollPosition + windowHeight >= blockTop && scrollPosition <= blockTop + blockHeight) {
        var ids = [];
        jQuery('[attr-post_id]').each(function () {
          ids.push(jQuery(this).attr('attr-post_id'));
        });
        var cat = jQuery('[attr-cat_id]').attr('attr-cat_id');
        var data = {
          'action': 'get_latest_posts',
          'ids': ids,
          'cat': cat
        };
        flag = false;
        jQuery.ajax({
          url: myajax.url,
          data: data,
          type: 'POST',
          success: function success(data) {
            if (data) {
              if (data != 'false') {
                if (data) {
                  jQuery('body .post-grid__row').append(data);
                  flag = true;
                }
              }
            }
          },
          error: function error() {}
        });
      }
    }
  }
  jQuery(window).scroll(function () {
    checkVisibility();
  });
  checkVisibility();
});